export default "__VITE_ASSET__h$2$vfRN__"